import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { STORY_CATEGORIES, type StoryCategoryId } from './success-stories.utils';

@Component({
  selector: 'app-success-stories-filter-bar',
  standalone: true,
  imports: [FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="cg-ss-filter" aria-label="Filter success stories">
      <div class="cg-container--marketing cg-ss-filter__inner">
        <div class="cg-ss-filter__categories" role="tablist" aria-label="Story categories">
          @for (category of categories; track category.id) {
            <button
              type="button"
              role="tab"
              class="cg-ss-filter__pill"
              [class.is-active]="activeCategory === category.id"
              [attr.aria-selected]="activeCategory === category.id"
              (click)="categoryChange.emit(category.id)"
            >
              {{ category.label }}
            </button>
          }
        </div>
        <label class="cg-ss-filter__search">
          <span class="cg-ss-filter__search-label">Search stories</span>
          <span class="cg-ss-filter__search-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="7"></circle>
              <path d="m20 20-3.5-3.5"></path>
            </svg>
          </span>
          <input
            type="search"
            name="storySearch"
            [ngModel]="searchQuery"
            (ngModelChange)="searchChange.emit($event)"
            placeholder="Search by university, country, or name…"
            autocomplete="off"
          />
        </label>
      </div>
    </section>
  `,
})
export class SuccessStoriesFilterBarComponent {
  readonly categories = STORY_CATEGORIES;

  @Input({ required: true }) activeCategory!: StoryCategoryId;
  @Input() searchQuery = '';
  @Output() categoryChange = new EventEmitter<StoryCategoryId>();
  @Output() searchChange = new EventEmitter<string>();
}
